import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { hasConversationsAccess } from '../../selectors/userSelectors/hasConversationsAccess';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  access: hasConversationsAccess(state)
});
const defaultProps = {
  exact: false,
  external: false,
  strict: false
};
/**
 * @description A specialized redirect (maintains most of the
 * same prop API as react-router's Redirect) that only renders
 * a Redirect component if the user doesn't have app access. If
 * the link goes outside of the application, the external prop
 * will use a Route to match the `from` prop and then use
 * `window.location` to handle redirects if that route is matched
 * for a user without access.
 */
class RedirectIfMissingAppScope extends PureComponent {
  handleExternalRedirect(path) {
    window.location = path;
    return null;
  }
  renderExternalRedirect() {
    const {
      access,
      exact,
      from,
      strict,
      to
    } = this.props;
    return /*#__PURE__*/_jsx(Route, {
      path: from,
      strict: strict,
      exact: exact,
      children: !access && this.handleExternalRedirect(to)
    });
  }
  renderInternalRedirect() {
    const {
      access,
      exact,
      from,
      strict,
      to
    } = this.props;
    return access ? null : /*#__PURE__*/_jsx(Redirect, {
      from: from,
      to: to,
      strict: strict,
      exact: exact
    });
  }
  render() {
    const {
      external
    } = this.props;
    return external ? this.renderExternalRedirect() : this.renderInternalRedirect();
  }
}
RedirectIfMissingAppScope.displayName = 'RedirectIfMissingAppScope';
RedirectIfMissingAppScope.defaultProps = defaultProps;
export default connect(mapStateToProps)(RedirectIfMissingAppScope);